// Carrega todas as dependências do JavaScript (Vue e outras bibliotecas)
require('../bootstrap');

import NowUiKit from './plugins/now-ui-kit';
Vue.use(NowUiKit);

import App from './App.vue';
import router from './router';

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');
